import axios from "axios";
import { message } from 'antd';
import {loadingAnimation} from "../common/commonLoading";

const network = axios.create({
    baseURL: "https://data.shanghailingye.cn/",
    timeout: 5000,
})

network.interceptors.request.use(config => {
    loadingAnimation(true)
    return config
})

network.interceptors.response.use(response => {
    loadingAnimation(false)
    // 如果回应了就直接return出去
    return response;
}, error => {
    loadingAnimation(false)
    // 令失败的响应为error
    let { response } = error;
    // 如果存在服务器响应
    if (response) {
        // 统一处理
        switch(response.status){
            case 401:
                break;
        }
    } else {
        if (!window.navigator.onLine) {
            message.error("请检查网络")
        }
        return Promise.reject(error);
    }
})

export default network;
